import { render, staticRenderFns } from "./BrokerOrder.vue?vue&type=template&id=5d3c096b&scoped=true&"
import script from "./BrokerOrder.vue?vue&type=script&lang=js&"
export * from "./BrokerOrder.vue?vue&type=script&lang=js&"
import style0 from "./BrokerOrder.vue?vue&type=style&index=0&id=5d3c096b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c096b",
  null
  
)

export default component.exports